//@ts-nocheck
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export type CallDetail = object

export interface SelectedCustomerType {
  id: string
  type: object
}

export interface SelectedOperatorType {
  id: string
  userExtension: string
}

export interface SelectedProductType {
  id: string
  name: string
  isNew: boolean
  requestedQuantity: string
}

export interface SubmitCallcenterFormRequestDto {
  extension: string
  phoneCallId: string
  type: 'lead' | 'source' | 'criticism' | 'transfer' | 'other' | 'CANCELLED'
  leadSource: number
  newLeadName: string
  preName: number
  selectedCustomer: SelectedCustomerType
  selectedOperator: SelectedOperatorType
  selectedProductTypes: SelectedProductType[]
  description: string
  transferredBusinessUnit: string
  isNewCustomer: boolean
  isOverload?: boolean
  isCooperationRequest?: boolean
}

export interface PriceInquiryProduct {
  productId: string
  productName: string
  unitId: string
  unitName: string
  quantity: number
  pricePerUnit: number
}

export interface SubmitPriceInquiryFormRequestDto {
  extension: string
  phoneCallId: string
  opportunityId: string
  products: PriceInquiryProduct[]
  selectedOperator: SelectedOperatorType
  leadSource: number
  isNewCustomer: boolean
  preName: number
  newLeadName: string
  selectedCustomer: SelectedCustomerType
  companyName: string
  phoneNumber: string[]
  companyPhone: string[]
  description: string
  cityOfEvacuation: string
  isQuoteRequested: boolean
}

export interface SubmitCallcenterFormResponse {
  opportunityId: string
  opportunityName: string
  isError: boolean
  massage: string
}

export interface SubmittedNote {
  entityName: string
  entityId: string
  description: string
}

export interface SubmitSalesPersonFollowUpRequestDto {
  extension: string
  phoneCallId: string
  selectedOperator: SelectedOperatorType
  leadSource: number
  isNewCustomer: boolean
  preName: number
  newLeadName: string
  selectedCustomer: SelectedCustomerType
  companyName: string
  phoneNumber: string[]
  companyPhone: string[]
  notes: SubmittedNote[]
}

export interface SubmitSalesPersonTransferRequestDto {
  extension: string
  phoneCallId: string
  selectedOperator: SelectedOperatorType
  leadSource: number
  isNewCustomer: boolean
  preName: number
  newLeadName: string
  selectedCustomer: SelectedCustomerType
  companyName: string
  phoneNumber: string[]
  companyPhone: string[]
  transferredBusinessUnit: string
}

export interface SubmitSalesPersonOthersRequestDto {
  extension: string
  phoneCallId: string
  selectedOperator: SelectedOperatorType
  leadSource: number
  isNewCustomer: boolean
  preName: number
  newLeadName: string
  selectedCustomer: SelectedCustomerType
  companyName: string
  phoneNumber: string[]
  companyPhone: string[]
  subject: string
  description: string
}

export interface OriginateData {
  fromExtension: string
  toExtension: string
}

export interface SearchInCustomer {
  name: string
}

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios'

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private secure?: boolean
  private format?: ResponseType

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    })
  }
}

/**
 * @title API
 * @version v0.0.1
 * @contact
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AppControllerWelcome
   * @request GET:/
   */
  appControllerWelcome = (params: RequestParams = {}) =>
    this.request<CallDetail[], any>({
      path: `/`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  callcenter = {
    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerGetLeadSource
     * @request GET:/callcenter/lead-source
     * @secure
     */
    callCenterControllerGetLeadSource: (params: RequestParams = {}) =>
      this.request<CallDetail, any>({
        path: `/callcenter/lead-source`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerGetProductTypes
     * @request GET:/callcenter/get-product-types
     * @secure
     */
    callCenterControllerGetProductTypes: (params: RequestParams = {}) =>
      this.request<CallDetail, any>({
        path: `/callcenter/get-product-types`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerGetOperators
     * @request GET:/callcenter/get-operators
     * @secure
     */
    callCenterControllerGetOperators: (params: RequestParams = {}) =>
      this.request<object[], any>({
        path: `/callcenter/get-operators`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerSubmitCallcenterForm
     * @request POST:/callcenter/submit-callcenter-form
     * @secure
     */
    callCenterControllerSubmitCallcenterForm: (data: SubmitCallcenterFormRequestDto, params: RequestParams = {}) =>
      this.request<CallDetail, any>({
        path: `/callcenter/submit-callcenter-form`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerSubmitPriceInquiryForm
     * @request POST:/callcenter/submit-sales-person-price-inquiry
     * @secure
     */
    callCenterControllerSubmitPriceInquiryForm: (data: SubmitPriceInquiryFormRequestDto, params: RequestParams = {}) =>
      this.request<SubmitCallcenterFormResponse, any>({
        path: `/callcenter/submit-sales-person-price-inquiry`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerSubmitSalesPersonFollowUp
     * @request POST:/callcenter/submit-sales-person-follow-up
     * @secure
     */
    callCenterControllerSubmitSalesPersonFollowUp: (
      data: SubmitSalesPersonFollowUpRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CallDetail, any>({
        path: `/callcenter/submit-sales-person-follow-up`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerSubmitSalesPersonTransfer
     * @request POST:/callcenter/submit-sales-person-transfer
     * @secure
     */
    callCenterControllerSubmitSalesPersonTransfer: (
      data: SubmitSalesPersonTransferRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CallDetail, any>({
        path: `/callcenter/submit-sales-person-transfer`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerSubmitSalesPersonOthers
     * @request POST:/callcenter/submit-sales-person-others
     * @secure
     */
    callCenterControllerSubmitSalesPersonOthers: (
      data: SubmitSalesPersonOthersRequestDto,
      params: RequestParams = {}
    ) =>
      this.request<CallDetail, any>({
        path: `/callcenter/submit-sales-person-others`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerOriginate
     * @request POST:/callcenter/originate
     * @secure
     */
    callCenterControllerOriginate: (data: OriginateData, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/callcenter/originate`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerSearchInCustomers
     * @request POST:/callcenter/search-in-customers
     * @secure
     */
    callCenterControllerSearchInCustomers: (data: SearchInCustomer, params: RequestParams = {}) =>
      this.request<CallDetail, any>({
        path: `/callcenter/search-in-customers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags callcenter
     * @name CallCenterControllerGetLeadPreNames
     * @request GET:/callcenter/getLeadPreNames
     * @secure
     */
    callCenterControllerGetLeadPreNames: (params: RequestParams = {}) =>
      this.request<CallDetail, any>({
        path: `/callcenter/getLeadPreNames`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  }
  voicePlayer = {
    /**
     * No description
     *
     * @name VoicePlayerControllerGetVoice
     * @request GET:/voice-player
     */
    voicePlayerControllerGetVoice: (
      query: {
        url: string
        download?: string
        authorization?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/voice-player`,
        method: 'GET',
        query: query,
        ...params,
      }),
  }
}
